<template>
	<label class="checkbox">
		<input type="checkbox" :disabled="disabled" v-model="inputValue" :checked="checked">
		<span :class="[typeClass]"></span>
	</label>
</template>
<script>
	export default {
		name: "Checkbox",
		props: {
			value: {
				type: Boolean,
				required: true,
			},
			disabled: {
				type: Boolean
			},
			checked: {
				type: Boolean
			},
			type: {
				type: String,
				default: ''
			}
		},
		computed: {
			inputValue: {
				get() {
					return this.value
				},
				set(val) {
					this.$emit('change', val)
				}
			},
			typeClass() {
				return this.type == '' ? `cb-checkmark` : `cb-checkmark-${this.type}`;
			}
		}
	}
</script>
<style lang="scss" scoped>
	.checkbox {
		width: 32px;
		height: 32px;
		display: block;
		position: relative;
		cursor: pointer;
		font-size: 22px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		input {
			opacity: 0;
			cursor: pointer;
		}
		input:checked ~ .cb-checkmark {
			background: #F75F39;
			border: 1px solid #F75F39;;
		}
		input:checked ~ .cb-checkmark:after {
			content: '';
			top: 5px;
			width: 12px;
			height: 17px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		}
		&:hover {
			input ~ .cb-checkmark {
				background-color: #ccc;
			}
			input:active ~ .cb-checkmark {
				transform: scale(0.95);
			}
			input:checked ~ .cb-checkmark {
				background: #DE5B3B;
				border: 1px solid #DE5B3B;
			}
		}
		.cb-checkmark {
			position: absolute;
			top: 0;
			left: 0;
			height: 32px;
			width: 32px;
			background: rgba(152, 141, 155, 0.38);
			border-radius: 0.5rem;
			transition: all 0.2s;
		}
		.cb-checkmark:after {
			content: "+";
			display: block;
			position: absolute;
			left: 50%;
			margin-left: -7px;
			font-weight: 500;
			color: white;
		}
		input:checked ~ .cb-checkmark-empty {
			background: #F75F39;
			border: 1px solid #F75F39;;
		}
		input:checked ~ .cb-checkmark-empty:after {
			content: '';
			top: 5px;
			width: 12px;
			height: 17px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		}
		&:hover {
			input ~ .cb-checkmark-empty {
				background-color: #ccc;
			}

			input:active ~ .cb-checkmark-empty {
				transform: scale(0.95);
			}

			input:checked ~ .cb-checkmark-empty {
				background: #de5b3b;
				border: 1px solid #de5b3b;
			}
		}

		.cb-checkmark-empty {
			position: absolute;
			top: 0;
			left: 0;
			height: 32px;
			width: 32px;
			border: 1px solid rgba(152, 141, 155, 0.38);
			border-radius: 0.5rem;
			transition: all 0.2s;
		}
		.cb-checkmark-empty:after {
			display: block;
			position: absolute;
			left: 50%;
			margin-left: -7px;
			font-weight: 500;
			color: white;
		}
	}
</style>
